import React, { useEffect, useState } from 'react';
import LoginPanelStyled from './LoginPanel.styled';
import { actions } from '@/redux/slices/user';
import Button, { ButtonStyles, ButtonTypes } from '@/components/button/Button';
import Input from '@/components/input/Input';
import LoadingSpinner from '@/components/loadingSpinner/LoadingSpinner';
import ErrorMessage from '@/components/errorMessage/ErrorMessage';
import Icon  from '@/components/icon/Icon';
import { IconsDictionary } from '@/components/icon/Icon.types';
import { selectAuthState } from '@/redux/selectors/user';
import { useDispatch, useSelector } from 'react-redux';
import useEventListener from '@/hooks/useEvenListener';
import PanelWrapper from '@/components/panelWrapper/PanelWrapper';


const isSafari = (): boolean => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined')
    return false;
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

const LoginPanel = () => {
  const { errorMessage, loading } = useSelector(selectAuthState);
  const dispatch = useDispatch();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const onSubmit = () => dispatch(actions.LOGIN_USER({ username, password }));
  const handleSso = () => (
    dispatch(
      actions.LOGIN_USER({
        sso: true,
        method: isSafari() ? 'redirect' : 'popup',
      })
    )
  )

  const onKeydown = (evt: KeyboardEvent) => {
    if (evt.key === 'Enter') onSubmit();
  };

  useEventListener('keydown', onKeydown);

  useEffect(() => {
    if (window.ContensisHideLogin) handleSso();
  }, []);

  return (
    <PanelWrapper>
      <LoginPanelStyled>
          {loading ? (
            <LoadingSpinner />
          ) : (
            <>
              <Icon icon={IconsDictionary.Contensis} height={136} width={218} />
              <span className="login-panel__title">
                Log in to your Contensis account
              </span>
              <form autoComplete="on" className="login-panel__container">
                <Input
                  className="login-panel__input"
                  type="text"
                  label="Username"
                  name="username"
                  id="username"
                  autoComplete="username"
                  placeholder="Username"
                  hasError={!!errorMessage}
                  _onChange={(e: any) => setUsername(e.target.value)}
                />
                <Input
                  className="login-panel__input"
                  id="login-panel--password"
                  type="password"
                  name="password"
                  label="Password"
                  placeholder="Password"
                  autoComplete="password"
                  hasError={!!errorMessage}
                  _onChange={(e: any) => setPassword(e.target.value)}
                />
                {errorMessage && <ErrorMessage message={errorMessage} />}
                <Button
                  className="login-panel__btn"
                  type={ButtonTypes.Default}
                  label="Login"
                  // isDisabled={!username || !password}
                  _onEnterPressed={e => {
                    e.preventDefault();
                    onSubmit();
                  }}
                  _onClick={e => {
                    e.preventDefault();
                    onSubmit();
                  }}
                />
                {window.ContensisSso && (
                  <Button
                    className="login-panel__btn"
                    btnStyle={ButtonStyles.Secondary}
                    type={ButtonTypes.Default}
                    label="Log in with single sign on"
                    _onClick={e => {
                      e.preventDefault();
                      handleSso();
                    }}
                    _onEnterPressed={e => {
                      e.preventDefault();
                      handleSso();
                    }}
                  />
                )}
              </form>
            </>
          )}
      </LoginPanelStyled>
    </PanelWrapper>
  );
};

export default LoginPanel;
